export const fareRates = [
    {
        id: 0,
        label: 'Standard',
    },
    {
        id: 1,
        label: 'Negotiated',
    },
];



// WEBPACK FOOTER //
// ./src/app/modules/cars/config/fare-rates-enum.js